var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('a',{staticClass:"send-rate-form__btn",class:_vm.new_rate.rate && _vm.new_rate.to  ? 'active' : 'disabled',on:{"click":function($event){return _vm.save()}}},[_vm._v("Отправить отзыв")])])}
var staticRenderFns = []

export { render, staticRenderFns }